import isEmpty from 'lodash/isEmpty';
import {YesNoChoice} from '@/model/src/values/dv-3';
import {RequestType} from '@/model/src/values/dv-4';
import {Operations} from '@/model/src/values/dv-48';
import {Condition} from '@/model/types';
import {Conditions} from './conditions';
import {and, or} from './conditions/utils';

export const isNewClient = Conditions.fields.eq('A7', YesNoChoice.YES);

export const isExistingClient = Conditions.fields.eq('A7', YesNoChoice.NO);

export const isNewAccount = Conditions.fields.eq('A9', RequestType.NEW_PLAN);

export const isExistingAccount = Conditions.fields.eq('A9', RequestType.EXISTING_PLAN);

export const isNewContract = or(isNewClient, isNewAccount);

// This is just the inverted order of isNewContract to keep model unchanged
// Add a variable so we can easily remove it when everything is migrated to isNewContract
export const isNewAdhesion = or(isNewAccount, isNewClient);

export const isOperation = <TOperation extends Operations>(operation: TOperation) =>
  Conditions.fields.eq('A16', operation);

export const isOperationIn = (...operations: Operations[]) => Conditions.fields.isIn('A16', operations);

export const isExistingClientAndExistingAccountForOperations = (operations: Operations[] = []) => {
  const operationsCondition = !isEmpty(operations) ? [isOperationIn(...operations)] : [];
  return and(isExistingClient, isExistingAccount, ...operationsCondition);
};

export const isExistingClientAndExistingAccount = isExistingClientAndExistingAccountForOperations();

export const isExistingClientAndNewAccount = and(isExistingClient, isNewAccount) satisfies Condition;

export const shouldGenerateProfileInvestorForm = Conditions.fields.eq('A18', YesNoChoice.YES);

export const shouldAddProfileInvestorForm = Conditions.fields.eq('A18', YesNoChoice.NO);
